'use client';

import { usePathname, useSearchParams } from 'next/navigation';

import { ErrorNotFound } from '@libs/shared-ui';

import SearchPageError from '@/components/SearchPageError';

export default function NotFoundPage() {
    const pathname = usePathname();
    const isSearchPage = pathname?.startsWith('/search');
    const searchParams = useSearchParams();
    const searchTerm = searchParams?.get('q');

    return isSearchPage ? <SearchPageError {...{ searchTerm }} /> : <ErrorNotFound />;
}
